import { IconName } from '@elearning-platform/ui';
import { ReactComponent as ModuleIcon } from '../dashboard/images/moduleIcon.svg';

export const Config = {
  moduleName: "dashboardV2",
  dependencies: [],
  label: "competence.app.dashboard.label",
  Icon: ModuleIcon,
  urls: ["/pulpit", "/"],
  routeName: "api_dashboard",
  routes: {},
  options: {},
  theme: {},
  modernIconName: IconName.PageDashboard,
  ignoreModuleFromGlobalState: true,
};